import { Checkbox } from "@progress/kendo-react-inputs";

export const DisplayNameHorizontallyProperty = {
  propertyName: "DisplayNameHorizontally",
  propertyDisplay: "Display Field Name Horizontally?",
  propertyType: "boolean",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <Checkbox
        name={this.propertyName}
        onChange={(e) => {
          handlePropertyChange({ propName: this.propertyName, propValue: e.target.value });
        }}
        defaultValue={currentPropertyValues?.[this.propertyName] || false}
      />
    );
  },
};
